import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import { $accountsFactory } from "../../$accounts.factory";

export class DemandAccountSelectCtrl implements IController {

  selectedId: any;
  branchIds: string[];
  depotIds: string[];
  options: any[];
  optionIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  isHideLabel: boolean;
  onChange: Function;


  private accountsRef: any;
  public selectedAccount: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $accounts: $accountsFactory, private $element) {
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())
      || (changes.branchIds && !changes.branchIds.isFirstChange()) ){
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const branchIdsRef = this.branchIds;
    const depotIdsRef = this.depotIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'depot-ids="ctrl.depotIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'account';
        this.selectedIdsRef = selectedIdRef;
        this.branchIdsRef = branchIdsRef;
        this.depotIdsRef = depotIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({account: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const account = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({account: account, id: selectedId});
            panel.destroy();
          } else {
            this.accountsRef.$asyncValues([selectedId])
              .then((accounts) => {
                this.onChange({account: accounts[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({account: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedAccount = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.accountsRef.$asyncValues([this.selectedId])
          .then((accounts) => {
            this.selectedAccount = _.orderBy(accounts, ['name'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedAccount = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedAccount, 'name', '');
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      branchIds: '<?',
      depotIds: '<?',
      options: '<?',
      optionIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      isHideLabel: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
    },
    template: require('./demand-account-select.html').default,
    controller: DemandAccountSelectCtrl
  });
